'use strict';

export default function AuthSelectScenario({ options, separatorKey, loginLabelKey, onSelectOption, onGoLogin }) {
    return (
        <div>
            <div className="reg-modal__title">
                {__('[Registration] Scenario title')}
            </div>
            {options.map((option) => (
                <div className="reg-modal__row" key={option.labelKey}>
                    {option.href
                        ? <a className="button button-gray" href={option.href} onClick={() => option.goal && ymReachGoal(option.goal)}>
                            {__(option.labelKey)}
                        </a>
                        : <a className="button button-gray" onClick={() => onSelectOption(option)}>
                            {__(option.labelKey)}
                        </a>}
                </div>
            ))}
            <div className="reg-modal__separator">
                <span>{__(separatorKey)}</span>
            </div>
            <div className="reg-modal__btns">
                <a className="button button-round-white" onClick={onGoLogin}>
                    {__(loginLabelKey)}
                </a>
            </div>
        </div>
    );
}
